export default __webpack_public_path__ + "static/poolsuite-7c3258583a2b078a0e14eccf59c65318.jpg";